import React from 'react';

import { CmsTag } from 'api/cms';
import { Box } from 'components/Box';
import Tag from 'components/Tag';

type Props = {
  homePageUrl: string;
  tags: Array<CmsTag>;
};

export function ContentPageTags({ homePageUrl, tags }: Props) {
  return (
    <Box data-qa-id="tags" display="flex" m="-6px">
      {tags.map((tag) => (
        <Tag
          key={tag.slug}
          component={homePageUrl && 'a'}
          disabled={!homePageUrl && 'disabled'}
          data-qa-id="tag-link"
          href={homePageUrl ? `/${homePageUrl}?tags.slug=${tag.slug}&pq=` : ''}
          m="6px"
        >
          {tag.tag}
        </Tag>
      ))}
    </Box>
  );
}
